import { render } from "./ModalPaymentMethod.vue?vue&type=template&id=66b05d9a"
import script from "./ModalPaymentMethod.vue?vue&type=script&lang=js"
export * from "./ModalPaymentMethod.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__